const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M419.543,332v-41a24.4,24.4,0,0,0-48.8,0v41H346.789a18.146,18.146,0,0,1-18.146-18.146V244.583l66.5-66.5,66.5,66.5v69.266A18.146,18.146,0,0,1,443.5,332Z",
    style: {
      fill: "#ffb14a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.137,333.285c-6.267-4.884-12.886-9.821-19.569-14.463h0L165.705,421.679,105.842,318.822h0c-70.721,45.583-79.333,103.538-81.1,168.646H306.672C306.163,440.925,298.989,373.136,245.137,333.285Z",
    style: {
      fill: "#7f99cc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.502,
    y: 262.571,
    width: 54.406,
    height: 74.191,
    style: {
      fill: "#ffcbbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.705,430.1s54.281-32.38,59.863-111.281c-11.155-7.748-22.489-14.673-32.66-19.155l-18.2,23.9H156.7l-18.2-23.9c-10.171,4.482-21.505,11.407-32.66,19.155C111.424,397.723,165.705,430.1,165.705,430.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.502 283.687 192.908 294.445 192.908 262.571 138.502 262.571 138.502 283.687",
    style: {
      fill: "#d38e89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.588,144.9s-14.4,3.58-22.495,22.183c-8.88,25.206,16.455,36.642,41.21,35.439V144.9Z",
    style: {
      fill: "#53737f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.822,144.9s14.4,3.58,22.5,22.183c8.879,25.206-16.455,36.642-41.21,35.439V144.9Z",
    style: {
      fill: "#53737f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.507,218.256h11.8V181.2h-11.8C55.977,182.05,55.991,217.414,80.507,218.256Z",
    style: {
      fill: "#ffcbbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.305,148.349v69.907a58.375,58.375,0,0,0,58.376,58.375h30.048a58.375,58.375,0,0,0,58.376-58.375V148.349Z",
    style: {
      fill: "#ffcbbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.9,218.256h-11.8V181.2h11.8C275.433,182.05,275.419,217.414,250.9,218.256Z",
    style: {
      fill: "#ffcbbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.705,39.288S82.937,25.835,79.587,118.561H251.822C248.473,25.835,165.705,39.288,165.705,39.288Z",
    style: {
      fill: "#ffb14a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.979,205.425c-8.436-.408-7.212-12.789,1.15-11.538C149.941,195.386,148.952,205.305,141.979,205.425Z",
    style: {
      fill: "#53737f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.429,205.425c-8.461-.4-7.221-12.78,1.136-11.538C197.373,195.376,196.4,205.3,189.429,205.425Z",
    style: {
      fill: "#53737f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.023,249.761a40.221,40.221,0,0,1-23.009-7.179c-6.19-4.526.2-13.783,6.63-9.569a28.813,28.813,0,0,0,34.082-.972c6.154-4.569,13.1,4.3,7.161,9.177A40.048,40.048,0,0,1,166.023,249.761Z",
    style: {
      fill: "#53737f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.423,
    y: 102.297,
    width: 66.564,
    height: 16.265,
    style: {
      fill: "#d37231"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.287,102.3H224.51A10.406,10.406,0,0,1,214.1,91.891V47.132c-23.166-11.937-48.4-7.844-48.4-7.844s-25.233-4.093-48.4,7.843v44.76A10.406,10.406,0,0,1,106.9,102.3H81.123a134.434,134.434,0,0,0-1.536,16.264H251.822A134.24,134.24,0,0,0,250.287,102.3Z",
    style: {
      fill: "#d37231"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.305,
    y: 148.436,
    width: 146.799,
    height: 23.771,
    style: {
      fill: "#d38e89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.324,146.351s3.657,27,33.15,34.546a10.637,10.637,0,0,0,13.049-8.494l.943-5.318s5.409,7.152,24.272,5.071c12.955-1.714,18.069-14.319,12.8-25.805Z",
    style: {
      fill: "#53737f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.471,
    y: 118.561,
    width: 192.468,
    height: 29.788,
    style: {
      fill: "#ffb14a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.882,22.608c-9.566.007-28.792,0-38.354,0a14.105,14.105,0,0,0-14.1,14.106v81.847h66.564V36.714A14.105,14.105,0,0,0,184.882,22.608Z",
    style: {
      fill: "#ffb14a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.705,430.653s13.313-8.221,27.43-25.87c-3.334-18.617-10.021-53.063-18.426-81.219H156.7c-8.405,28.156-15.092,62.6-18.426,81.219C152.392,422.432,165.705,430.653,165.705,430.653Z",
    style: {
      fill: "#53737f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.263,239.072a5.8,5.8,0,0,1-4.115-1.705l-88-88-88,88a5.82,5.82,0,1,1-8.232-8.23l92.119-92.118a5.819,5.819,0,0,1,8.232,0l92.118,92.118C495.065,232.588,492.261,239.254,487.263,239.072Z",
    style: {
      fill: "#d85656"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.263,239.072c4.944.165,7.853-6.469,4.116-9.935l-92.118-92.118a5.819,5.819,0,0,0-8.232,0L298.91,229.137a5.82,5.82,0,1,0,8.232,8.23l88-88,88,88A5.8,5.8,0,0,0,487.263,239.072Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.466,313.85V244.583a5.823,5.823,0,0,0-1.7-4.116l-66.5-66.5a5.821,5.821,0,0,0-8.232,0l-66.5,66.5a5.823,5.823,0,0,0-1.7,4.116V313.85a23.993,23.993,0,0,0,23.966,23.965h23.957a5.821,5.821,0,0,0,5.82-5.821v-41a18.579,18.579,0,0,1,37.157,0v41a5.821,5.821,0,0,0,5.82,5.821H443.5A23.993,23.993,0,0,0,467.466,313.85Zm-72.321-53.077a30.253,30.253,0,0,0-30.219,30.218v35.183H346.789a12.339,12.339,0,0,1-12.326-12.324V246.994l60.682-60.681,60.68,60.681V313.85A12.338,12.338,0,0,1,443.5,326.174H425.364V290.991A30.253,30.253,0,0,0,395.145,260.773Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.987,206.379c8.415-.33,7.2-12.839-1.136-11.524C134.048,196.242,135.053,206.352,141.987,206.379Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.052,202.785c3.1,7.025,13.518,2.7,10.739-4.452C191.7,191.318,181.269,195.645,184.052,202.785Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.887,242.18c5.927-4.87-.983-13.75-7.161-9.177a28.819,28.819,0,0,1-34.083.972,5.82,5.82,0,1,0-6.628,9.569,40.456,40.456,0,0,0,47.872-1.364Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.933,412.9a5.821,5.821,0,0,0-5.821,5.82v6.733H219.17c-7.663.189-7.685,11.444,0,11.64h42.423a5.82,5.82,0,0,0,0-11.64h-4.878V404.715a5.821,5.821,0,0,0-11.641,0v20.742h-9.322v-6.733A5.82,5.82,0,0,0,229.933,412.9Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.672,494.249a5.82,5.82,0,0,0,5.82-5.767c-.466-46.9-7.84-115.009-60.418-156.13-6.017-4.71-13.22,3.914-7.4,8.98,46,36.349,54.677,92.859,56.08,141.277H30.658c1.985-59.493,12.85-113.492,70.411-152.262,8.97,72.132,62.283,111.964,67.617,105.718,1.3.109,60.639-39.452,62.337-118.284A5.906,5.906,0,0,0,228.888,315a225.386,225.386,0,0,0-30.16-18.1v-16.08a64.329,64.329,0,0,0,45.92-55.789H250.9c15.11.17,26.957-14.249,23.886-29.024,13.445-14.928,6.167-35.279-7.03-47.26v-29.23a5.821,5.821,0,0,0-5.82-5.821h-4.61c-3.572-49.261-29.65-68.44-52.522-75.7a19.956,19.956,0,0,0-19.925-20.247H146.528A19.956,19.956,0,0,0,126.6,37.994C103.477,45.327,77.633,64.613,74.08,113.7H69.471a5.821,5.821,0,0,0-5.82,5.821v29.229c-13.109,11.88-20.528,32.4-7.016,47.17-3.126,14.8,8.723,29.287,23.872,29.115h6.254a64.332,64.332,0,0,0,45.92,55.789v16.08C114.466,305.887,99.2,316.95,82.7,329.655,27.366,370.666,19.367,439.718,18.919,488.483a5.819,5.819,0,0,0,5.819,5.766ZM165.7,424.03c-7.4-5.565-12.666-10.189-21.2-20.185,3.216-17.642,9.17-47.752,16.568-73.5h9.291c7.387,25.709,13.334,55.763,16.553,73.415A121.329,121.329,0,0,1,165.7,424.03Zm-6.11-105.324-15.263-20.042V283.1c8.856.537,33.908.538,42.766,0v15.568l-15.263,20.042ZM200.664,311c6.462,3.57,12.718,7.523,18.832,11.682-2.653,29.378-12.434,51.885-23.149,68.291-3.535-18.337-8.86-43.414-15.222-65.264L194.7,307.883C196.681,308.854,198.7,309.925,200.664,311ZM250.9,213.4h-5.978V187.983H250.9C267.722,188.58,267.716,212.8,250.9,213.4Zm6.532-58.123c7.794,5.926,16.544,18.515,11.351,28.95-6.743-7.213-14.14-8.281-23.861-7.882V155.13h12.353C257.334,155.175,257.377,155.231,257.435,155.274ZM138.243,37.675a8.294,8.294,0,0,1,8.285-8.284h38.354a8.294,8.294,0,0,1,8.285,8.284V113.7H138.243ZM86.485,213.4H80.507a12.707,12.707,0,1,1,0-25.414h5.978Zm0-37.055c-9.706-.4-17.112.672-23.84,7.859-5.2-10.606,3.623-23.07,11.486-29.071H86.485ZM75.291,143.49V125.343c1.92-.013,28.2.009,30.941,0,7.671-.193,7.679-11.446,0-11.641H85.757C88.331,80.8,102.045,59.52,126.6,50.309v69.214a5.82,5.82,0,0,0,5.82,5.82h66.564a5.82,5.82,0,0,0,5.82-5.82V50.313c24.557,9.227,38.271,30.508,40.847,63.389H225.178c-7.671.194-7.679,11.446,0,11.641,2.855,0,28.9,0,30.941,0V143.49Zm22.835,75.727V155.13h19.245c3.281,9.5,12.282,26.388,35.661,32.367a16.542,16.542,0,0,0,19.448-10.269c7.6,2.928,27.09,4.17,34.878-5.225a5.82,5.82,0,1,0-8.411-8.046,11.181,11.181,0,0,1-6.847,3.375c-13.416,1.472-18.326-2.266-19.074-2.927-2.788-4.4-9.667-2.457-10.29,2.626-.7,2.791-.408,7-3.111,8.574a4.654,4.654,0,0,1-3.708.615c-15.256-3.9-22.572-13.735-26-21.09H233.284c.037,15.33-.027,48.536,0,64.087a52.615,52.615,0,0,1-52.555,52.556H150.681A52.615,52.615,0,0,1,98.126,219.217Zm38.585,88.666,13.573,17.824c-6.372,21.888-11.7,47.012-15.239,65.356-10.7-16.388-20.476-38.91-23.132-68.39A209.306,209.306,0,0,1,136.711,307.883Z",
    style: {
      fill: "#333"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/생산관리.0bbfb48282b0a918d51407921a31d01e.svg";
export { ForwardRef as ReactComponent };